import { Button } from "@touche-lts/panel-ui/dist";
import { observer } from "mobx-react-lite";
import { useRootStore } from "mobx-stores/store-provider";
import { Department } from "models/departments";
import { useEffect, useState } from "react";
import styles from "./footer.module.scss";
import cl from "classnames";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MESSAGE_MIN_LENGTH = 10;
const MESSAGE_MAX_LENGTH = 255;

const FooterComponent = () => {
  const {
    routingStore: { push },
    departmentsStore: { getAllDepartments, allDepartments },
    generalStore,
  } = useRootStore();

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    getAllDepartments();
  }, [getAllDepartments]);

  const handleSendMessage = async () => {
    if (isSending) return;
    const customerEmail = email.trim();
    const messageBody = message.trim();

    if (!customerEmail || !EMAIL_REGEX.test(customerEmail)) {
      generalStore.showError("Please enter a valid email address.");
      return;
    }
    if (messageBody.length < MESSAGE_MIN_LENGTH) {
      generalStore.showError(
        `Message must be at least ${MESSAGE_MIN_LENGTH} characters.`,
      );
      return;
    }
    if (messageBody.length > MESSAGE_MAX_LENGTH) {
      generalStore.showError(
        `Message must be at most ${MESSAGE_MAX_LENGTH} characters.`,
      );
      return;
    }

    setIsSending(true);
    try {
      await generalStore.api.supportApi.sendSupportEmail({
        customerEmail,
        messageBody,
      });
      generalStore.showSuccess("Your message has been sent.");
      setEmail("");
      setMessage("");
    } catch {
      // Errors are already surfaced via generalStore.handleApiError
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className={styles.footerContainer}>
      <div className={cl(styles.footerContent)}>
        <div className="row">
          <div className="col-12">
            <h2>Shop by departments</h2>
          </div>
          <div
            className={cl(
              "col-12 col-lg-8",
              styles.departmentsContainer,
              styles.thinScroll,
            )}
          >
            {!allDepartments.length ? (
              <div>No departments availble</div>
            ) : (
              <div className="row mt-4">
                <div className="col-6 col-md-4">
                  {allDepartments &&
                    allDepartments
                      .slice(0, Math.ceil(allDepartments.length / 3))
                      .map((department: Department) => {
                        return (
                          <div
                            key={department?.id}
                            onClick={() =>
                              push("/departments/" + department?.id)
                            }
                            className={styles.departmentName}
                          >
                            {department?.name}
                          </div>
                        );
                      })}
                </div>
                <div className="col-6 col-md-4">
                  {allDepartments &&
                    allDepartments
                      .slice(
                        Math.ceil(allDepartments.length / 3),
                        Math.ceil(allDepartments.length * (2 / 3)),
                      )
                      .map((department: Department) => {
                        return (
                          <div
                            key={department?.id}
                            onClick={() =>
                              push("/departments/" + department?.id)
                            }
                            className={styles.departmentName}
                          >
                            {department?.name}
                          </div>
                        );
                      })}
                </div>
                <div className="col-12 col-md-4">
                  {allDepartments &&
                    allDepartments
                      .slice(
                        Math.ceil(allDepartments.length * (2 / 3)),
                        allDepartments.length - 1,
                      )
                      .map((department: Department) => {
                        return (
                          <div
                            key={department?.id}
                            onClick={() =>
                              push("/departments/" + department?.id)
                            }
                            className={styles.departmentName}
                          >
                            {department?.name}
                          </div>
                        );
                      })}
                </div>
              </div>
            )}
          </div>
          <div className="col-12 col-lg-4">
            <div className={styles.footerContactUs}>
              <h2>Contact us</h2>
              <h4>Email</h4>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSending}
              />
              <h4>Message</h4>
              <textarea
                placeholder="Leave us a message..."
                cols={10}
                rows={10}
                maxLength={MESSAGE_MAX_LENGTH}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                disabled={isSending}
              ></textarea>
              <Button
                preset="primary"
                onClick={handleSendMessage}
                disabled={isSending}
              >
                Send message
              </Button>
            </div>
          </div>
        </div>
        <hr className={styles.footerSeparationLine} />
        <div className={cl(styles.fooerCopyrightLinks, "row")}>
          <div className="col-12 col-lg-8">
            © Copyright {new Date().getFullYear()} Touch-E • All rights reserved
          </div>
          <div className="col-12 col-lg-4">
            <div className={styles.footerLinks}>
              {/* <a href="/terms">Terms & Conditions</a>
                            <a href="/privacy-policy">Privacy policy</a> */}
              <a href="/terms">All policies</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Footer = observer(FooterComponent);
export { Footer };
